const YoureStillTheOne = [
	'[Verse 1]',
	"Looks like we made it, Look how far we've come my baby",
	"We mighta took the long way, We knew we'd get there someday",
	'They said, "I bet they\'ll never make it"',
	'But just look at us holding on',
	"We're still together still going strong",
	'',
	'[Chorus]',
	"You're still the one",
	"You're still the one I run to",
	'The one that I belong to',
	"You're still the one I want for life",
	"You're still the one",
	"You're still the one that I love",
	'The only one I dream of',
	"You're still the one I kiss good night",
	'',
	'[Verse 2]',
	"Ain't nothin' better",
	'We beat the odds together',
	"I'm glad we didn't listen",
	"Look at what we would be missin'",
	'They said, "I bet they\'ll never make it"',
	'But just look at us holding on',
	"We're still together still going strong",
	'',
	'[Chorus]',
	"You're still the one",
	"You're still the one I run to",
	'The one that I belong to',
	"You're still the one I want for life",
	"You're still the one",
	"You're still the one that I love",
	'The only one I dream of',
	"You're still the one I kiss good night",
	'',
	'[Chorus]',
	"You're still the one",
	"You're still the one I run to",
	'The one that I belong to',
	"You're still the one I want for life",
	"You're still the one",
	"You're still the one that I love",
	'The only one I dream of',
	"You're still the one I kiss good night",
	"I'm so glad we made it",
	"Look how far we've come my baby",
];

export default YoureStillTheOne;
